import { render } from "./BulkAddAnswer.vue?vue&type=template&id=1bc9d625"
import script from "./BulkAddAnswer.vue?vue&type=script&lang=js"
export * from "./BulkAddAnswer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__